import { c as _c } from "react/compiler-runtime";
import useStore from '@/components/playbook-builder/hooks/use-store';
type RulesErrorContext = {
  contextType: 'rules_error_context';
  conditionId: string;
  problemMarkers: {
    message: string;
  }[];
};
const getInfoMessage = (context: RulesErrorContext, fallbackMessage: string) => context.problemMarkers?.[0]?.message || fallbackMessage;

/**
 * Returns a map of conditionId -> info message for rules conditions that have
 * info-level feedback from the backend (context.contextType === 'rules_error_context').
 * Does not use form state — read-only display data.
 */
export const useRulesInfoMessages = nodeId => {
  const $ = _c(3);
  const {
    data: t0
  } = useStore();
  const {
    banners
  } = t0;
  let map;
  if ($[0] !== banners || $[1] !== nodeId) {
    map = new Map();
    for (const banner of banners) {
      if (banner.type !== "info" || banner.nodeId !== nodeId) {
        continue;
      }
      const context = banner.description.context as RulesErrorContext | undefined;
      if (context?.contextType !== "rules_error_context") {
        continue;
      }
      const message = getInfoMessage(context, banner.description.message);
      map.set(context.conditionId, message);
    }
    $[0] = banners;
    $[1] = nodeId;
    $[2] = map;
  } else {
    map = $[2];
  }
  return map;
};